import { NAV } from './nav';

// 功能使用频率统计：记录每次进入某功能模块的次数，首页「常用功能」据此自动排序；
// 无使用数据时随机推荐 4 个板块。

const KEY = (uid?: string) => `yk_usage_${uid || 'guest'}`;

export function recordUsage(uid: string | undefined, path: string) {
  if (!path || path === '/dashboard') return;
  try {
    const k = KEY(uid);
    const map = JSON.parse(localStorage.getItem(k) || '{}');
    map[path] = (map[path] || 0) + 1;
    localStorage.setItem(k, JSON.stringify(map));
  } catch {
    /* 忽略存储异常 */
  }
}

export function pickQuickFeatures(uid: string | undefined, n = 4) {
  const feats = NAV.filter((f) => f.to !== '/dashboard');
  // 随机洗牌：初始无数据时随机出现，有数据时作为同分的随机排序
  for (let i = feats.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [feats[i], feats[j]] = [feats[j], feats[i]];
  }
  let map: Record<string, number> = {};
  try {
    map = JSON.parse(localStorage.getItem(KEY(uid)) || '{}');
  } catch {
    /* 忽略存储异常 */
  }
  const total = Object.values(map).reduce((s, v) => s + (v || 0), 0);
  if (!total) return feats.slice(0, n);
  return feats.sort((a, b) => (map[b.to] || 0) - (map[a.to] || 0)).slice(0, n);
}
